import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getLastOperation = (params) => {
    return axios.get(`${backendHost}/api/admin/report-games/list_id`, {params});
};

export {
    getLastOperation
}